import * as React from 'react';

import Image from 'lib/image-container';
import { useDetectPrint } from 'lib/use-detect-print';
import { MediaQueryWidth } from 'lib/use-media-query';
import useScrollbarWidth from 'lib/use-scrollbar-width';

import { Columns } from 'components/columns';
import ColumnsItem, { ColumnsSize } from 'components/columns/columns-item';
import { CtaBox, CtaBoxHeader, CtaBoxText } from 'components/cta-box';
import PageSection from 'components/page/page-section';
import {
  COLUMNS_GAP_MEDIUM,
  IMAGE_MAX_WIDTH_1,
  PAGE_PADDING_LARGE,
  PAGE_PADDING_MEDIUM,
  PAGE_PADDING_SMALL,
} from 'components/page/sections';

import { getPropsSectionSevenContainer } from './section-seven-container.props';

export const SectionSevenContainer: React.FC = () => {
  const props = getPropsSectionSevenContainer();
  const scrollbarWidth = useScrollbarWidth(true);
  const isPrinting = useDetectPrint();
  return (
    <>
      <div className="navigation-block" id={props.sections.one.id}>
        <PageSection extraClass="section-cta" padding="bottom" inner={true}>
          <CtaBox align="start">
            <CtaBoxText>{props.sections.one.text}</CtaBoxText>
          </CtaBox>
        </PageSection>
      </div>
      <PageSection color="peach" extraClass="section-cta" padding="block" inner={true}>
        <Columns hasMobileLayout={true}>
          <ColumnsItem size={isPrinting ? ColumnsSize['1/1'] : ColumnsSize['2/3']}>
            <CtaBox align="start">
              <CtaBoxHeader tag="h2">{props.sections.two.titleElement}</CtaBoxHeader>
              <CtaBoxText>{props.sections.two.text}</CtaBoxText>
            </CtaBox>
          </ColumnsItem>
          {isPrinting ? null : (
            <ColumnsItem verticalAlign="stretch" size={ColumnsSize['1/3']}>
              <Image
                width={536}
                height={620}
                style={{
                  objectFit: 'contain',
                  objectPosition: props.sections.two.imageObjectPosition,
                }}
                quality={75}
                src={props.sections.two.imageSrc}
                alt=""
                sizes={`
                    (max-width: ${MediaQueryWidth['desktop-sm']}px) calc(100vw - 2 * ${PAGE_PADDING_SMALL} - ${scrollbarWidth}),
                    (max-width: ${MediaQueryWidth['tablet-lg']}px) calc((100vw - 2 * ${PAGE_PADDING_MEDIUM} - ${COLUMNS_GAP_MEDIUM} - ${scrollbarWidth}) / 2),
                    (max-width: ${MediaQueryWidth['content-max']}px) calc((100vw - 2 * ${PAGE_PADDING_LARGE} - ${COLUMNS_GAP_MEDIUM} - ${scrollbarWidth}) / 2),
                    ${IMAGE_MAX_WIDTH_1}
                `}
              />
            </ColumnsItem>
          )}
        </Columns>
      </PageSection>
    </>
  );
};
